import { LimitNames, PlanTypes } from '../types';

export const DOCS_BY_LIMIT_NAME = {
  [LimitNames.HOSTS]: 'https://launchdarkly.com/docs/home/account/service-connections',
  [LimitNames.MONTHLY_ACTIVE_USERS]: 'https://launchdarkly.com/docs/home/account/calculating-billing',
};

export const oneLinerDescriptionByLimitName: { [key in LimitNames]?: string } = {
  [LimitNames.HOSTS]: '1 server-side SDK connected to a LaunchDarkly environment for one month',
  [LimitNames.MONTHLY_ACTIVE_USERS]: 'Each client-side user or device creates a client-side MAU',
  [LimitNames.EXPERIMENTATION_MAU]: 'Monthly number of users available to be targeted in experiments',
};

// Canonical ordering of billing limit types for UI rendering.
// Includes display-only limits; excludes hidden ones (SSO, SERVICE_CONNECTIONS).
//
// DEPRECATED: For a subscription's *current* limits, prefer the backend-provided
// `_limitDetails` array (already sorted) instead of this constant. This constant is
// retained ONLY for *future* limits (`subscription._next`), because the backend's
// FutureSubscriptionRep does not yet emit `_limitDetails`. Once the backend adds
// `_limitDetails` to future subscriptions (built from the scheduled change's
// effective limits using the same display order), the remaining `_next` consumers
// (ManagePlan, AnnualFoundationPlanInfo) can switch over and this constant can be
// removed entirely.
export const BILLING_LIMIT_ORDER: Array<Exclude<LimitNames, LimitNames.SERVICE_CONNECTIONS | LimitNames.SSO>> = [
  LimitNames.SEATS,
  LimitNames.HOSTS,
  LimitNames.MONTHLY_ACTIVE_USERS,
  LimitNames.AI_RUNS,
  LimitNames.EXPERIMENTATION_MAU,
  LimitNames.EXPERIMENTATION_KEYS,
  LimitNames.EVENTS_RECEIVED,
  LimitNames.EVENTS_PUBLISHED,
  LimitNames.SESSIONS,
  LimitNames.ERRORS,
  LimitNames.LOGS,
  LimitNames.TRACES,
  LimitNames.VEGA_AI,
];

export const OBSERVABILITY_LIMITS = new Set<LimitNames>([
  LimitNames.SESSIONS,
  LimitNames.ERRORS,
  LimitNames.TRACES,
  LimitNames.LOGS,
]);

export const USAGE_UNLIMITED = -1;
export const USAGE_WARNING_THRESHOLD = 75;
export const USAGE_ERROR_THRESHOLD = 100;
export const DEFAULT_USAGE_PRECISION = 2;

export const MS_PER_HOUR = 60 * 60 * 1000;
export const MS_PER_DAY = 24 * MS_PER_HOUR;

// TODO: remove this constant (and its consumers) after AI runs billing is released.
// Until that date, AgentControl AI runs are surfaced in checkout as "free" — see
// `enableAIRunsCheckoutDisplay` and the `aiRunsProduct` `displayOnly: true` config.
export const AGENT_CONTROL_FREE_PROMO_END = new Date('2026-07-01T00:00:00Z');

// Plan groupings
export const TRIAL_PLAN_TYPES: ReadonlySet<PlanTypes> = new Set([
  PlanTypes.STANDARD_TRIAL,
  PlanTypes.STANDARD_TRIAL2021,
  PlanTypes.ENTERPRISE_TRIAL,
  PlanTypes.FOUNDATION_TRIAL2023,
  PlanTypes.GUARDIAN_TRIAL2024,
]);
